import React from 'react';
import PropTypes from 'prop-types';
import { invoiceReceiptDateTime } from 'utils/formatter';
import styles from './InfoBox.css';

class InfoBox extends React.Component {
  render() {
    const { createdAt, collectedBy, paymentNo, servedBy } = this.props;
    return (
      <div className={styles['receipt-info-box']}>
        <div className={styles['receipt-date']}>
          <div className="pull-left">
            {invoiceReceiptDateTime(createdAt, 'date')}
          </div>
          <div className="pull-right">
            {invoiceReceiptDateTime(createdAt, 'time')}
          </div>
        </div>

        <div className={styles['receipt-number']}>
          <div className="pull-left">Receipt Number</div>
          <div className="pull-right">{paymentNo}</div>
        </div>

        <div className={styles['receipt-served']}>
          <div className="pull-left">Served By</div>
          <div className="pull-right">{servedBy}</div>
        </div>

        <div className={styles['receipt-collected']}>
          <div className="pull-left">Collected By</div>
          <div className="pull-right">{collectedBy}</div>
        </div>
      </div>
    );
  }
}

InfoBox.propTypes = {
  servedBy: PropTypes.string,
  collectedBy: PropTypes.string,
  paymentNo: PropTypes.string,
  createdAt: PropTypes.object,
};

export default InfoBox;
